import PropTypes from 'prop-types';
import { useNavigate } from 'react-router';

import { TreatmentClaimDiscrepancyNotification } from './TreatmentClaimDiscrepancyNotification';
import { TreatmentClaimPaidNotification } from './TreatmentClaimPaidNotification';
import { TreatmentClaimRejectedNotification } from './TreatmentClaimRejectedNotification';
import { TreatmentClaimReversedNotification } from './TreatmentClaimReversedNotification';

import { AppRoutes } from 'services/routes';

const TREATMENT_CLAIM_REJECTED_TOPIC = 'treatmentClaimRejected';
const TREATMENT_CLAIM_PAID_TOPIC = 'treatmentClaimPaid';
const TREATMENT_CLAIM_DISCREPANCY_TOPIC = 'treatmentClaimDiscrepancy';
const TREATMENT_CLAIM_REVERSED_TOPIC = 'treatmentClaimReversed';

/**
 * Dispatches RES_WATCH rows by additionalData.kafka_topic.
 * Owns treatment claims navigation (marketplace pattern).
 * Unknown topics render nothing until a card is implemented.
 */
export const ResourceWatchNotification = ({
    additionalData = undefined,
    linkingId = undefined,
    payerId = undefined,
    onNotificationClick,
    ...rest
}) => {
    const navigate = useNavigate();
    const topic = additionalData?.kafka_topic;

    const handleNotificationClick = () => {
        onNotificationClick();
        if (payerId && linkingId) {
            navigate(`${AppRoutes.treatmentDetails(payerId, linkingId)}#claims`);
        }
    };

    const cardProps = {
        additionalData,
        onNotificationClick: handleNotificationClick,
        ...rest,
    };

    if (topic === TREATMENT_CLAIM_REJECTED_TOPIC) {
        return <TreatmentClaimRejectedNotification {...cardProps} />;
    }

    if (topic === TREATMENT_CLAIM_PAID_TOPIC) {
        return <TreatmentClaimPaidNotification {...cardProps} />;
    }

    if (topic === TREATMENT_CLAIM_DISCREPANCY_TOPIC) {
        return <TreatmentClaimDiscrepancyNotification additionalData={additionalData} {...rest} />;
    }

    if (topic === TREATMENT_CLAIM_REVERSED_TOPIC) {
        return <TreatmentClaimReversedNotification additionalData={additionalData} {...rest} />;
    }

    return null;
};

ResourceWatchNotification.propTypes = {
    additionalData: PropTypes.shape({
        kafka_topic: PropTypes.string,
    }),
    linkingId: PropTypes.string,
    payerId: PropTypes.string,
    onNotificationClick: PropTypes.func.isRequired,
};
